import { z } from 'zod';

export const profileSchema = z.object({
    full_name: z.string().min(1, 'Please enter your name!'),
    username: z
        .string()
        .min(1, 'Please enter your username!')
        .min(5, 'Please ensure your username is 5 - 48 characters long')
        .max(48, 'Please ensure your username is 5 - 48 characters long')
        .regex(
            /^[A-Za-z0-9_-]+$/,
            'Username can only contain letters [A-Z, a-z], numbers [0-9], dashes & underscores [-_]!'
        ),
    email: z.string().min(1, 'Please enter a valid email!').email('Please enter a valid email!'),
    phone_number: z.string().min(1, 'Please enter a valid phone number!'),
});

export type ProfileFormData = z.infer<typeof profileSchema>;
